import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'

@jsonClass('ToolbarBlock')
export class ToolbarBlock extends Block {
	constructor(init: Partial<ToolbarBlock> = {}) {
		super()
		this.init(init)
	}
	getPreviewDirection() {
		return 'row' as const
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}
}
